"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const OMNI_ORANGE = "#C2501F";

const OmniComparisonSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const raw = t("omniComparison.rows", { returnObjects: true });
  const rows = Array.isArray(raw) ? raw : [];

  const headerColors = {
    oldWay: "#B6A9DF",
    omniWay: "#FFFFFF",
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, sm: 8, md: 10 },
        backgroundColor: "#F7F3FF",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 5 } }}>
          <Typography
            sx={{
              fontSize: { xs: "10px", sm: "11px" },
              fontWeight: 600,
              color: OMNI_ORANGE,
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              fontFamily: "var(--font-outfit)",
              mb: { xs: 1.5, sm: 2 },
            }}
          >
            {t("omniComparison.label")}
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "24px", sm: "28px", md: "32px", lg: "36px" },
              fontWeight: 700,
              lineHeight: 1.25,
              color: "#14122B",
              fontFamily: "var(--font-plusjakarta)",
            }}
          >
            {t("omniComparison.heading")}
          </Typography>
        </Box>

        {/* Table */}
        <Box
          sx={{
            borderRadius: "16px",
            overflow: "hidden",
            backgroundColor: "#FFFFFF",
            border: "1px solid #EEE9F7",
            boxShadow: "0 4px 24px rgba(122,43,245,0.05)",
          }}
        >
          {/* Header row */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              backgroundColor: "#14122B",
            }}
          >
            {["oldWay", "omniWay"].map((key) => (
              <Typography
                key={key}
                sx={{
                  px: { xs: 2, sm: 3, md: 4 },
                  py: { xs: 1.75, md: 2.25 },
                  fontSize: { xs: "10px", sm: "11px" },
                  fontWeight: 500,
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  color: headerColors[key],
                  fontFamily: "var(--font-outfit)",
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t(`omniComparison.columns.${key}`)}
              </Typography>
            ))}
          </Box>

          {/* Body rows */}
          {rows.map((row, index) => (
            <Box
              key={index}
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                borderTop: index === 0 ? "none" : "1px solid #F3EEF6",
              }}
            >
              <Typography
                sx={{
                  px: { xs: 2, sm: 3, md: 4 },
                  py: { xs: 1.75, md: 2.25 },
                  fontSize: { xs: "12px", sm: "13px", md: "13.5px" },
                  color: "#7A7A92",
                  fontWeight: 400,
                  fontFamily: "var(--font-outfit)",
                  backgroundColor: "#FFFFFF",
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {row.old}
              </Typography>

              <Typography
                sx={{
                  px: { xs: 2, sm: 3, md: 4 },
                  py: { xs: 1.75, md: 2.25 },
                  fontSize: { xs: "12px", sm: "13px", md: "13.5px" },
                  color: "#14122B",
                  fontWeight: 600,
                  fontFamily: "var(--font-outfit)",
                  backgroundColor: "#FFFAF7",
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {row.omni}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default OmniComparisonSection;